import React, {memo, useEffect, useState} from "react";
import "./customerSelection.scss";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import ZeusButton from "../../components/Button";
import {
  saveSelectedCustomer,
  requestCustomers,
} from "../../redux/Actions/customers.actions";
import {getCustomers} from "../../redux/Selectors/customers.selectors";

const CustomerSelection = () => {
  const navigate = useNavigate();
  const [open, toggleModal] = useState(true);
  const [customer, handleCustomerSelection] = useState();
  const dispatch = useDispatch();
  const customers = useSelector(getCustomers);

  useEffect(() => {
    const callback = (data = {}) => {
      if (data.results && data.results.length == 0) {
        toggleModal(false);
        navigate("/app/customer", {isFromDefaultRoute: true});
      }
    };

    dispatch(requestCustomers("", callback));
  }, [dispatch, navigate]);

  return (
    <Modal
      data-cy={"select_customer_modal"}
      unmountOnClose={true}
      isOpen={open}
      toggle={toggleModal}
      backdrop={"static"}
    >
      <ModalHeader>Select Customer</ModalHeader>
      <ModalBody>
        <ListGroup className="custome-scrollbar">
          {customers?.results?.length > 0 &&
            customers.results.map((eachCustomer, index) => {
              const isActive = customer && customer.id === eachCustomer.id;
              return (
                <ListGroupItem
                  style={{
                    color: isActive ? "#ffffff" : "#525f7f",
                    cursor: "pointer",
                  }}
                  active={isActive}
                  action
                  tag="a"
                  onClick={() => handleCustomerSelection(eachCustomer)}
                  key={index}
                >
                  {eachCustomer.name}
                </ListGroupItem>
              );
            })}
        </ListGroup>
      </ModalBody>
      <ModalFooter>
        {customer && (
          <ZeusButton
            data-cy={"select_customer"}
            onClick={() => {
              dispatch(saveSelectedCustomer(customer));
            }}
          >
            {"CONFIRM"}
          </ZeusButton>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default memo(CustomerSelection);
